import { render, staticRenderFns } from "./MyUserChangePassword.vue?vue&type=template&id=0f86f904&"
import script from "./MyUserChangePassword.vue?vue&type=script&lang=js&"
export * from "./MyUserChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports